var map = {
	"./badges/pl_badge-bestseller.svg": 3026,
	"./badges/pl_badge-buy-subscription.svg": 4391,
	"./badges/pl_badge-new-bestseller.svg": 7857,
	"./badges/pl_badge-new.svg": 8145,
	"./badges/pl_badge-presale.svg": 2229,
	"./badges/pl_badge-preview.svg": 6207,
	"./badges/pl_badge-promo.svg": 1402,
	"./icons/01_book.svg": 4587,
	"./icons/02_book.svg": 6538,
	"./icons/android.svg": 7581,
	"./icons/app-store-badge.jpg": 4464,
	"./icons/app-store-badge.svg": 4915,
	"./icons/apple.svg": 5560,
	"./icons/arrow-down.svg": 6064,
	"./icons/arrow-left.svg": 9039,
	"./icons/arrow-right.svg": 218,
	"./icons/arrow-up.svg": 8243,
	"./icons/author.svg": 9593,
	"./icons/bank-transfer.svg": 3550,
	"./icons/basket-quick.svg": 852,
	"./icons/basket.svg": 2750,
	"./icons/blik.svg": 3694,
	"./icons/book-read.svg": 5860,
	"./icons/book.svg": 9655,
	"./icons/bookmark-o.svg": 6144,
	"./icons/bookmark.svg": 4088,
	"./icons/card.svg": 3826,
	"./icons/chevron_down.svg": 3416,
	"./icons/chevron_up.svg": 7003,
	"./icons/close.svg": 4732,
	"./icons/danger.svg": 4745,
	"./icons/download.svg": 3704,
	"./icons/e-mail.svg": 791,
	"./icons/ekiosk_A5_U1_spinner.svg": 3174,
	"./icons/ekiosk_F2_fav.svg": 5087,
	"./icons/ekiosk_L1_button.svg": 4271,
	"./icons/email.svg": 5072,
	"./icons/envelope.svg": 5156,
	"./icons/eye.svg": 4359,
	"./icons/facebook.png": 8587,
	"./icons/facebook.svg": 6716,
	"./icons/favorite.svg": 6852,
	"./icons/filter.svg": 5942,
	"./icons/google-play-badge.jpg": 7677,
	"./icons/google-play-badge.png": 7037,
	"./icons/group-copy-8.svg": 934,
	"./icons/hamburger.svg": 3181,
	"./icons/heart-o.svg": 7372,
	"./icons/heart.svg": 9716,
	"./icons/info.svg": 404,
	"./icons/instagram.png": 2555,
	"./icons/instagram.svg": 684,
	"./icons/key.svg": 9333,
	"./icons/link.svg": 4760,
	"./icons/login.svg": 5631,
	"./icons/logo-n-border.svg": 3827,
	"./icons/logo-n.svg": 2552,
	"./icons/newspaper.svg": 2585,
	"./icons/nexto-points.svg": 7866,
	"./icons/payment.svg": 610,
	"./icons/pen-line.svg": 4064,
	"./icons/pen.svg": 7977,
	"./icons/pencil-fill.svg": 6219,
	"./icons/plus-lg.svg": 9110,
	"./icons/plus.svg": 3496,
	"./icons/points.png": 8202,
	"./icons/points.svg": 1733,
	"./icons/polygon.svg": 6298,
	"./icons/profil.svg": 1110,
	"./icons/profile-add.svg": 417,
	"./icons/profile-shadow.svg": 8324,
	"./icons/profile.svg": 5895,
	"./icons/publisher.svg": 6480,
	"./icons/question_mark.svg": 7652,
	"./icons/question_mark_active.svg": 5249,
	"./icons/reader.svg": 9481,
	"./icons/search.svg": 644,
	"./icons/slider-arrow-left.svg": 7975,
	"./icons/slider-arrow-right.svg": 6994,
	"./icons/sort.svg": 3284,
	"./icons/star-filled.svg": 8293,
	"./icons/star.svg": 4904,
	"./icons/success.svg": 4121,
	"./icons/times-bold.svg": 4326,
	"./icons/times.svg": 4082,
	"./icons/trash.svg": 4542,
	"./icons/twitter.svg": 3693,
	"./icons/ulubione.svg": 5521,
	"./icons/warning.svg": 5092,
	"./icons/youtube_social_icon_dark_64.png": 1246,
	"./logos/ekiosk-logo.png": 2591,
	"./logos/ekiosk-logo.svg": 5568,
	"./logos/facebook-logo.svg": 3522,
	"./logos/instagram-logo.svg": 4374,
	"./logos/youtube-logo.svg": 9384,
	"./mail/button-app-store.png": 7138,
	"./mail/button-google-play.png": 8403,
	"./mail/logo-ekiosk-dark.png": 7445,
	"./mail/logo-ekiosk-light.png": 7773,
	"./mail/media-facebook-dark.png": 7932,
	"./mail/media-facebook-light.png": 8550,
	"./mail/media-instagram-dark.png": 3624,
	"./mail/media-instagram-light.png": 5306,
	"./mail/media-youtube-dark.png": 1985,
	"./mail/media-youtube-light.png": 481,
	"./others/author_default_cover.svg": 2468,
	"./others/books.png": 8796,
	"./others/books_small.png": 4484,
	"./others/comment-blue.svg": 1875,
	"./others/comment-yellow.svg": 8879,
	"./others/cover-64x64.jpg": 2532,
	"./others/cover-big.jpg": 3750,
	"./others/cover-small.jpg": 3117,
	"./others/default_cover.svg": 4662,
	"./others/dog-empty.png": 8936,
	"./others/dog-with-questionmark.png": 9569,
	"./others/dog_404.svg": 4834,
	"./others/dog_book.png": 1162,
	"./others/dog_book.svg": 4645,
	"./others/dog_cookies.svg": 3635,
	"./others/dog_cookies2.svg": 2955,
	"./others/dog_error.png": 8835,
	"./others/dog_key.svg": 6819,
	"./others/dog_tick.svg": 9173,
	"./others/download-app-phone-ios.webp": 6050,
	"./others/download-app-phone.webp": 8862,
	"./others/eKiosk_points.png": 6825,
	"./others/eye.svg": 534,
	"./others/line.svg": 6053,
	"./others/loader.svg": 1022,
	"./others/loader_fixed.svg": 1745,
	"./others/play.png": 6998,
	"./others/premium.png": 8309,
	"./others/publisher_default_cover.svg": 6495,
	"./others/quickbuy.png": 6891,
	"./others/user_relax.png": 9978,
	"./payu/pbl_ap.png": 5972,
	"./payu/pbl_blik.png": 9825,
	"./payu/pbl_jp.png": 7937,
	"./users/user_portrait.png": 1511
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 5756;